/** Shift names the search index carries; the server drops any other name from a SHIFT filter. */
export const FILTERABLE_SHIFTS = ['first', 'second', 'third'] as const;

export type FilterableShift = (typeof FILTERABLE_SHIFTS)[number];

/**
 * Options offered by the languages filter, in the lowercase form the index stores.
 * Deliberately curated (ONE-6510) rather than free text, so a typo can't silently
 * narrow a search to no stated match.
 */
export const FILTERABLE_LANGUAGES = ['english', 'spanish'] as const;

export type FilterableLanguage = (typeof FILTERABLE_LANGUAGES)[number];

/**
 * Responsiveness levels the filter offers, in the lowercase form the index stores. The offered
 * slice is also what a hydrated URL is checked against, so `?responsiveness=low` can't stage a
 * filter with no chip to reveal or clear it.
 */
export const FILTERABLE_RESPONSIVENESS = ['high'] as const;

export type FilterableResponsiveness = (typeof FILTERABLE_RESPONSIVENESS)[number];

/**
 * How far back "Recently open to work" reaches (six weeks). The only place the duration is
 * decided: the server derives its date bounds from this day count.
 */
export const RECENT_OPEN_TO_WORK_DAYS = 42;

/** The server drops any pay bound above this as a unit error (an annual figure, not hourly). */
export const MAX_HOURLY_PAY_RATE = 1000;
